import React, { useEffect, useState,  useCallback} from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import API_BASE_URL from "../services/apiClient";
import { useLocation } from "react-router-dom";
/* NORMALIZER */
// import { normalizeItinerary } from "../utils/itinearary/normalizeItinerary";

/* HUB COMPONENTS */
import HubSidebar from "../components/hub/HubSidebar";
import OverviewDashboard from "../components/hub/OverviewDashboard";
import MobileTabBar from "../components/hub/MobileTabBar";
import ItineraryTrip from "../components/ItineraryTrip";
/* TABS */
import PackingList from "../components/PackingList";
// import OneDayItinerary from "../components/itinerary/OneDayItinerary";
// import MultiDayItinerary from "../components/itinerary/MultiDayItinerary";
import TicketsPage from "./TicketPage";
import StaysPage from "./StaysPage";
import ExpensesPage from "./ExpensesPage";
import DocumentsPage from "./DocumentsPage";
import TripSharePage from "./TripSharePage";
import TripHelp from "./TripHelp";
import MobileMorePage from "../components/hub/MobileMorePage";
const TripHubPage = () => {

  const { travelKeyToken } = useParams();
  const navigate = useNavigate();

  const [trip, setTrip] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("overview");
  const [user, setUser] = useState(null);

  /* ================= FETCH TRIP ================= */
const location = useLocation();

useEffect(() => {
  if (location.state?.tab) {
    setActiveTab(location.state.tab);
  }
}, [location.state]);
  const fetchTrip = useCallback(async () => {
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");

   if (!token) {

    localStorage.setItem(
    "redirectAfterLogin",
    window.location.href
    );

    navigate("/");

    return;
    }

    try {
      const res = await fetch(`${API_BASE_URL}/api/trips/${travelKeyToken}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.ok) {
        const data = await res.json();
        setTrip(data);
      } else {
        console.error("Trip fetch failed");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [travelKeyToken, navigate]);

  useEffect(() => {
    fetchTrip();
  }, [fetchTrip]);

  /* ================= USER ================= */

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user")) || JSON.parse(sessionStorage.getItem("user"));
    if (storedUser) setUser(storedUser);
  }, []);

  /* ================= NORMALIZED DATA ================= */

  // const normalizedTrip = useMemo(() => {
  //   if (!trip) {
  //     return { days: [], meta: { budget: "", transportation: "" } };
  //   }
  //   return normalizeItinerary(trip);
  // }, [trip]);

  const deleteTrip = async () => {
    const confirmDelete = window.confirm("Are you sure you want to permanently delete this trip?");
    if (!confirmDelete) return;

    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    try {
      await fetch(`${API_BASE_URL}/api/trips/${travelKeyToken}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate("/profile");
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  /* ================= TRIP META ================= */

  // const tripMetadata = useMemo(() => {
  //   if (!trip) return { cityName: "Trip Hub", dates: "Loading..." };

  //   const cityData = trip.cities?.[0];
  //   const cityName = cityData?.cityName || "Trip Hub";
  //   const tripLength = normalizedTrip.days.length;
  //   const dates = tripLength <= 1 ? "1-Day Explorer" : `${tripLength}-Day Adventure`;

  //   return { cityName, dates, cityData };
  // }, [trip, normalizedTrip]);

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div className="min-h-screen bg-[#fdfcf7] flex flex-col items-center justify-center p-6 bg-gradient-to-br from-[#fdfcf7] to-white">
        <div className="relative w-20 h-20 mb-6 flex items-center justify-center">
          <div className="absolute inset-0 border-4 border-[#5b6f00]/20 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-[#5b6f00] border-t-transparent rounded-full animate-spin"></div>
          <svg className="w-8 h-8 text-[#5b6f00] animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" /></svg>
        </div>
        <p className="text-xs font-bold text-[#5b6f00] uppercase tracking-widest animate-pulse drop-shadow-sm">
          Initializing Hub...
        </p>
      </div>
    );
  }

  /* ================= NOT FOUND ================= */

  if (!trip) {
    return (
      <div className="min-h-screen bg-[#fdfcf7] flex flex-col items-center justify-center p-6 text-center">
        <div className="w-24 h-24 bg-red-50 text-red-500 rounded-3xl flex items-center justify-center mb-8 shadow-sm">
          <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
        </div>
        <h2 className="text-4xl font-black text-gray-900 mb-4 tracking-tight">Access Denied</h2>
        <p className="text-gray-500 mb-10 max-w-sm text-lg font-medium">This adventure is offline or doesn't exist.</p>
        <button
          onClick={() => navigate("/dashboard")}
          className="bg-gray-900 text-white px-10 py-4 rounded-2xl font-bold shadow-xl shadow-gray-900/20 hover:bg-gray-800 hover:-translate-y-1 active:scale-95 transition-all"
        >
          Return to Dashboard
        </button>
      </div>
    );
  }

  /* ================= RENDER CONTENT ================= */

  const pageVariants = {
    initial: { opacity: 0, y: 10, filter: "blur(4px)" },
    in: { opacity: 1, y: 0, filter: "blur(0px)" },
    out: { opacity: 0, y: -10, filter: "blur(4px)" }
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.3
  };

  const renderContent = () => {
    switch (activeTab) {
      case "overview":
        return <OverviewDashboard trip={trip} user={user} startDate={trip?.cities?.[0]?.startDate} onNavigate={setActiveTab} travelKeyToken={travelKeyToken} />;
      case "packing":
        return <PackingList onPackingUpdate={fetchTrip} />;
     case "itinerary":
return (

<ItineraryTrip
trip={trip}
travelKeyToken={travelKeyToken}
refreshTrip={fetchTrip}
/>

);
      case "tickets":
        return <TicketsPage onTabChange={setActiveTab} />;
      case "stays":
        return <StaysPage onTabChange={setActiveTab} />;
      case "expenses":
        return <ExpensesPage onTabChange={setActiveTab} />;
      case "documents":
        return <DocumentsPage onTabChange={setActiveTab} />;
      case "invite":
        navigate(`/trip/${travelKeyToken}/invite`);
        return null;
      case "share":
        return <TripSharePage onTabChange={setActiveTab} />;
      case "help":
        return <TripHelp onTabChange={setActiveTab} />;
      case "menu":
        return (
          <MobileMorePage
            onTabChange={setActiveTab}
            onDeleteTrip={deleteTrip}
          />
        );
      default:
        return <OverviewDashboard trip={trip} startDate={trip?.cities?.[0]?.startDate} user={user} onNavigate={setActiveTab} travelKeyToken={travelKeyToken} />;

    }
  };

  /* ================= PAGE ================= */

  // For responsive padding on mobile vs desktop.
  // We use `pb-24` on mobile so content doesn't get hidden behind MobileTabBar.
  return (
    <div className="min-h-screen bg-[#fafaf9] text-gray-900 font-sans selection:bg-[#5b6f00]/30 selection:text-[#5b6f00] relative">
      <div className="flex max-w-[1920px] mx-auto">
        {/* SIDEBAR */}
        <HubSidebar
          activeTab={activeTab}
          onTabChange={setActiveTab}
          onDeleteTrip={deleteTrip}
        />

        {/* MAIN CONTENT */}
        <main className="flex-1 min-h-screen p-4 md:p-8 lg:p-10 overflow-x-hidden pb-24 lg:pb-10">
          <div className="max-w-[1200px] mx-auto w-full">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial="initial"
                animate="in"
                exit="out"
                variants={pageVariants}
                transition={pageTransition}
                className="w-full"
              >
                {renderContent()}
              </motion.div>
            </AnimatePresence>
          </div>
        </main>
      </div>

      {/* BOTTOM NAV BAR DEDICATED TO MOBILE */}
      <MobileTabBar activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
};

export default TripHubPage;